module.exports = __webpack_public_path__ + "assets/fba2dad18aa5ba8406d28af087d6041b.mp4";